import { INamedEntity, INamedEntityImt } from 'common/interfaces/common';
import { PaymentsType } from 'common/interfaces/invoices';
import { ImmutableObject } from 'common/state/interfaces';
import { List as ImmutableList } from 'immutable';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';

// Payment Methods Default
export enum PaymentMethodCustomStatuses {
  NEW = 'NEW',
  USED = 'USED',
  BLOCKED = 'BLOCKED',
}

export enum ProcessingType {
  Peak = 'PEAK',
  InClubTerminal = 'IN_CLIENT_TERMINAL',
}
export interface IPaymentMethodItem {
  active: boolean;
  club: INamedEntity;
  deleted: boolean;
  id: string;
  invoiceAmountPercentage: number;
  paymentMethodInstanceCount: number;
  processingType: ProcessingType;
  storeBalance: boolean;
  title: string;
  type: PaymentsType;
}

export interface IPaymentMethodItemImt extends ImmutableObject<IPaymentMethodItem> {
  get<K extends keyof IPaymentMethodItem>(key: K): IPaymentMethodItem[K];
}

export interface IPaymentMethodsPosSettingsImt extends ImmutableObject<IPaymentMethodItem> {
  get<K extends keyof IPaymentMethodItem>(key: K): IPaymentMethodItem[K];
}

// Payment Method Item List
export interface IPaymentMethodCustomItem {
  id?: string;
  active?: boolean;
  title?: string;
  name?: string;
  clubsCount?: number;
  barcode?: number | string;
  amount?: number | string;
  leftAmount?: number | string | null;
  createdDate?: string;
  employee?: IEmployeeBasicInfo | null;
  status?: PaymentMethodCustomStatuses;
}

export interface IPaymentMethodCustomFormData {
  invoiceAmountPercentage: string;
  title: string;
  storeBalance?: boolean;
  active: boolean;
}

export interface IPaymentMethodCustomItemPosSettingsImt
  extends ImmutableObject<IPaymentMethodCustomItem> {
  get<K extends keyof IPaymentMethodCustomItem>(key: K): IPaymentMethodCustomItem[K];
}

// Payment Method Custom Item add

export interface IPaymentMethodCustomInstanceFormData {
  name: string;
  barcode: string;
  amount: string;
  clubs: Array<string>;
}
export interface IPaymentMethodCustomItemClubsFormData {
  id?: string;
  name?: string;
  title?: string;
  barcode?: string;
  amount?: string | number;
  club?: INamedEntity;
  clubs?: Array<INamedEntity>;
}

export interface IPaymentMethodCustomItemClubsFormDataImt
  extends ImmutableObject<IPaymentMethodCustomItemClubsFormData> {
  get<K extends keyof IPaymentMethodCustomItemClubsFormData>(
    key: K,
  ): IPaymentMethodCustomItemClubsFormData[K];

  get(key: 'club'): INamedEntityImt;
  get(key: 'clubs'): ImmutableList<Array<INamedEntityImt>>;
}
